<template>
    <v-card elevation="0" class="ma-0 pa-0">
        <v-card v-if="model == null" height="20px" elevation="0">
            <v-progress-linear
                    color="red accent-4"
                    indeterminate
                    rounded
                    height="6"
            ></v-progress-linear>
        </v-card>
        <v-card v-else elevation="0">
            <v-card-actions class="ma-0 pa-0">
                <v-text-field class="ma-0 pa-0 pt-1"
                              v-model="model.name"
                              label="Package Name"
                              dense
                              outlined
                ></v-text-field>
            </v-card-actions>
            <v-card-actions class="ma-0 pa-0">
                <v-text-field class="ma-0 pa-0"
                              v-model="model.description"
                              label="Package Description"
                              dense
                              outlined
                ></v-text-field>
            </v-card-actions>
<!--            <v-card-actions class="ma-0 pa-0">-->
<!--                <v-autocomplete-->
<!--                        v-model="model.packageType"-->
<!--                        dense-->
<!--                        :items="types"-->
<!--                        outlined-->
<!--                        item-text="name"-->
<!--                        item-value="id"-->
<!--                        return-object-->
<!--                        small-chips-->
<!--                        deletable-chips-->
<!--                        label="Type"-->
<!--                ></v-autocomplete>-->
<!--            </v-card-actions>-->
            <v-card-actions class="ma-0 pa-0">
                <v-autocomplete
                        v-model="model.type"
                        dense
                        :items="activationTypes"
                        outlined
                        item-text="name"
                        item-value="id"
                        return-object
                        small-chips
                        deletable-chips
                        label="Activation Type"
                ></v-autocomplete>
            </v-card-actions>
            <v-card-actions class="ma-0 pa-0">
                <v-card outlined width="100%" class="ma-0 pa-0">
                    <v-card-actions class="ma-0 pa-2">
                        <v-card-text class="ma-0 pa-0 ml-3 grey--text">users: {{getUsers()}}</v-card-text>
                        <v-spacer></v-spacer>
                        <v-btn color="green"
                               elevation="0"
                               class="white--text pl-5 pr-3"
                               @click="onPressImport">
                            Import Users *.csv
                            <v-icon class="ml-2">mdi-database-import-outline</v-icon>
                        </v-btn>
                        <v-btn color="red"
                               elevation="0"
                               class="white--text pl-5 pr-3"
                               @click="onPressClearUsers">
                            clear
                            <v-icon class="ml-2">mdi-delete</v-icon>
                        </v-btn>
                        <input ref="uploader"
                               class="d-none"
                               type="file"
                               accept=".csv"
                               @change="onFileChanged">
                    </v-card-actions>
                </v-card>
            </v-card-actions>
        </v-card>
    </v-card>
</template>

<script>

import {PackageType} from "@/modules/mpackages/models/PackeageType";
import {ActivationType} from "@/modules/mpackages/models/ActivationType";

export default {
    name: "p-setup-info",
    components: {},
    data: () => ({
        type: null,
        model:null,
    }),
    created() {
    },
    methods: {
        getUsers(){
            let length = this.model.availableFor.length
            return length == 0 ? "All" : length
        },
        onPressClearUsers(){
            this.model.availableFor = []
        },
        setModel(model){
            this.model = model.copy()
        },
        onPressImport(){
            window.addEventListener('focus', () => {
            }, { once: true })
            this.$refs.uploader.click()
        },
        onFileChanged(e){
            e.target.files[0].text()
            .then((fetchedCsv)=>{
                this.model.availableFor = fetchedCsv.split(/\r?\n/)
            })
            .catch((error) => {
                throw error
            })
        },
        validate() {
            return {data:this.model, error: ''}
        }
    },
    computed: {
        types() {
            return PackageType.getValues()
        },

        activationTypes() {
            return ActivationType.getValues()
        },
    },
}
</script>

<style scoped>
</style>